import React, { useState, useEffect } from "react";
import "./Template_3.css";

const Template_3_MainHeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="Template_3 main-hero-section">
      <div className="Template_3 hero-content">
        <div
          className={`Template_3 content-inner ${
            isVisible ? "Template_3 visible" : ""
          }`}
        >
          <div className="Template_3 badge">
            <span>Bespoke Luxury</span>
          </div>

          <h1 className="Template_3 main-title">
            <span className="Template_3 title-line">Unveil The</span>
            <span className="Template_3 title-line Template_3 accent">
              World's
            </span>
            <span className="Template_3 title-line">Finest Treasures</span>
          </h1>

          <div className="Template_3 tagline-container">
            <div className="Template_3 tagline">
              <div className="Template_3 tagline-icon">♦</div>
              <p>Exquisite Horizons</p>
            </div>
            <div className="Template_3 tagline">
              <div className="Template_3 tagline-icon">♦</div>
              <p>Timeless Elegance</p>
            </div>
            <div className="Template_3 tagline">
              <div className="Template_3 tagline-icon">♦</div>
              <p>Eternal Memories</p>
            </div>
          </div>

          <div className="Template_3 cta-container">
            <button className="Template_3 cta-button Template_3 primary">
              Commence Journey
              <span className="Template_3 button-icon">→</span>
            </button>
            <button className="Template_3 cta-button Template_3 secondary">
              Browse Locales
            </button>
          </div>
        </div>
      </div>

      <div className="Template_3 overlay-pattern"></div>
    </div>
  );
};

export default Template_3_MainHeroSection;
